export const MomentFormatEnums = {
    date_time: 'YYYY-MM-DD HH:mm:ss',
};
